import { Signal, useSignal } from '@preact/signals-react';
import { toast } from 'react-toastify';
import ActionButton from '../../../atoms/ActionButton';
import Dialog from '../../../organisms/Dialog';
import { personApi } from '../../../../services/personApi';
import { formatTaxId } from '../../../../utils/taxIdUtils';

const DIALOG_ID = 'dialog-registration-notification';
const NOTIFY_LABEL = 'Notificar cadastro atualizado';
const SENT_MESSAGE = 'Notificação enviada';

interface Props {
    personId: string;
    legalName: string;
    govTaxId: string;
    enabled: boolean;
    reason: string;
}

const sendNotification = async (personId: string, isOpen: Signal<boolean>, isSending: Signal<boolean>) => {
    isSending.value = true;
    try {
        await personApi.notifyRegistrationUpdated(personId);
        toast.success(SENT_MESSAGE);
        isOpen.value = false;
    } catch (error: any) {
        toast.error(error.message);
    } finally {
        isSending.value = false;
    }
};

const LegalPersonRegistrationNotification = ({ personId, legalName, govTaxId, enabled, reason }: Props) => {
    const isOpen = useSignal(false);
    const isSending = useSignal(false);

    return (
        <div className="mb-1 flex items-center gap-2">
            <ActionButton variant="success" size="sm" disabled={!enabled} onClick={() => { isOpen.value = true; }}>
                {NOTIFY_LABEL}
            </ActionButton>
            {reason && <span className="text-xs text-gray-500 dark:text-gray-400">{reason}</span>}
            <Dialog
                id={DIALOG_ID}
                show={isOpen.value}
                onClose={() => { isOpen.value = false; }}
                header={NOTIFY_LABEL}
                size="sm"
                body={
                    <p className="px-6 py-4 text-sm text-gray-700 dark:text-gray-200">
                        Avisar o jurídico de que o cadastro de {legalName} (CNPJ {formatTaxId(govTaxId)}) está atualizado e pode ser usado nas operações?
                    </p>
                }
                footer={
                    <div className="flex gap-2">
                        <ActionButton variant="secondary" size="sm" onClick={() => { isOpen.value = false; }}>
                            Cancelar
                        </ActionButton>
                        <ActionButton
                            variant="success"
                            size="sm"
                            loading={isSending.value}
                            onClick={() => sendNotification(personId, isOpen, isSending)}
                        >
                            Notificar
                        </ActionButton>
                    </div>
                }
            />
        </div>
    );
};

export default LegalPersonRegistrationNotification;
